import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { SEARCH_BY_FIELD } from 'constants/index';
import { mapProps } from 'modules/shell/hoc/mapProps';
import { withConfig } from 'modules/shell/hoc/withConfig';
import { createFullClientsProfile } from 'modules/clients/actions';
import { withFeatureToggles } from 'modules/shell/hoc/withFeatureToggles';
import { BG_UCA_ACCOUNT_CREATION_FLOW } from 'constants/featureToggleNames';
import styles from './AddProfileForm.styles';
import AddProfileForm from './AddProfileForm';

// Logic of initial form fields are implemented according AC-2 of https://neimanmarcus.atlassian.net/browse/OSP-3029
export const prepareInitialFormValues = ({ searchTerm, searchBy, ...restOwnProps }) => {
  const initialValues = {};
  const trimmedSearchTerm = searchTerm.trim();

  if (trimmedSearchTerm) {
    // eslint-disable-next-line default-case
    switch (searchBy) {
      case SEARCH_BY_FIELD.NAME:
        {
          const firstSpacePosition = trimmedSearchTerm.indexOf(' ');

          if (firstSpacePosition > -1) {
            initialValues.firstName = trimmedSearchTerm.slice(0, firstSpacePosition);
            initialValues.lastName = trimmedSearchTerm.slice(firstSpacePosition + 1);
          } else {
            initialValues.firstName = trimmedSearchTerm;
          }
        }
        break;

      case SEARCH_BY_FIELD.PHONE:
        initialValues.phone = trimmedSearchTerm;
        break;

      case SEARCH_BY_FIELD.EMAIL:
        initialValues.email = trimmedSearchTerm;
        break;
    }
  }

  return { ...restOwnProps, initialValues };
};

const mapStateToProps = ({ user }) => ({
  user: user.data,
});

const mapDispatchToProps = {
  createFullClientsProfile,
};

export default compose(
  mapProps(prepareInitialFormValues),
  withConfig(),
  withFeatureToggles({
    bgAccountCreationFlowEnabled: BG_UCA_ACCOUNT_CREATION_FLOW,
  }),
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
)(AddProfileForm);
